import { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Row, Col, Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { FaCloudUploadAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import Select from "react-select";

const ServiceSubCategoryModal = ({
  show,
  handleClose,
  currentSubService,
  fetchSubServicesData,
}) => {
  const [formData, setFormData] = useState({
    service_sub_category_name: "",
    service_sub_cat_description: "",
    service_sub_image: null,
    imagePreviewUrl: null,
    service_category: "",
  });

  const [errors, setErrors] = useState({});

  const inputRef = useRef(null);
  const [service, setService] = useState("");
  const [serviceCat, setServiceCat] = useState([]);
  useEffect(() => {
    fetchServiceCatData();
  }, []);

  const fetchServiceCatData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/service-categories/?page_size=all`,
        {
          headers: HEADERS,
        },
      );
      setServiceCat(response.data.results || []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const serviceOptions = serviceCat.map((svc) => ({
    value: svc.id,
    label: svc.service_category_name,
  }));

  useEffect(() => {
    if (currentSubService) {
      setFormData({
        service_sub_category_name:
          currentSubService.service_sub_category_name || "",
        service_sub_cat_description:
          currentSubService.service_sub_cat_description || "",
        service_sub_image: currentSubService.service_sub_image,
        imagePreviewUrl: currentSubService.service_sub_image || null,
        service_category: currentSubService.service_category.id || "",
      });
      setService(currentSubService.service_category.id || "");
    } else {
      resetForm();
    }
  }, [currentSubService]);

  const resetForm = () => {
    setFormData({
      service_sub_category_name: "",
      service_sub_cat_description: "",
      service_sub_image: null,
      imagePreviewUrl: null,
      service_category: "",
    });
    setService("");
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "service_sub_image") {
      const file = files[0];
      if (file) {
        if (!file.type.startsWith("image/")) {
          setFormData({
            ...formData,
            service_sub_image: null,
            imagePreviewUrl: null,
          });
          toast.error(
            "Invalid image format. Please upload a valid image file.",
          );
          return;
        }

        setFormData({
          ...formData,
          service_sub_image: file,
          imagePreviewUrl: URL.createObjectURL(file),
        });
        setErrors({ ...errors, service_sub_image: null });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
      setErrors({ ...errors, [name]: null });
    }
  };

  const validateFields = () => {
    let fieldErrors = {};
    if (!formData.service_sub_category_name) {
      fieldErrors.service_sub_category_name =
        "Service Sub Category Name is required.";
    }
    if (!formData.service_sub_cat_description) {
      fieldErrors.service_sub_cat_description =
        "Service Sub Category Description is required.";
    }
    return fieldErrors;
  };

  const handleIconClick = () => {
    inputRef.current.click();
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    const payload = new FormData();
    payload.append(
      "service_sub_category_name",
      formData.service_sub_category_name,
    );
    payload.append(
      "service_sub_cat_description",
      formData.service_sub_cat_description,
    );
    payload.append("service_category", service);

    if (
      formData.service_sub_image &&
      typeof formData.service_sub_image !== "string"
    ) {
      payload.append("service_sub_image", formData.service_sub_image);
    }

    setLoading(true);

    try {
      let response;
      if (currentSubService) {
        response = await axios.put(
          `${BASE_URL}/api/service-sub-categories/${currentSubService.id}/`,
          payload,
          {
            headers: {
              ...HEADERS,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      } else {
        response = await axios.post(
          `${BASE_URL}/api/service-sub-categories/`,
          payload,
          {
            headers: {
              ...HEADERS,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      }

      if (response) {
        toast.success(response.data.message);
        fetchSubServicesData();
        handleClose();
        resetForm();
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {currentSubService
            ? "Edit Service Subcategory"
            : "Add Service Subcategory"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Floating className="mb-3">
            <Form.Control
              type="text"
              id="service_sub_category_name"
              name="service_sub_category_name"
              placeholder="Service Sub-Category Name"
              value={formData.service_sub_category_name}
              onChange={handleChange}
              required
            />
            <label htmlFor="service_sub_category_name">
              Service Sub Category Name*
            </label>
          </Form.Floating>

          <Row className="align-items-center mb-3">
            <Col xs={6} className="text-center">
              <div style={{ display: "inline-block", width: "100%" }}>
                <Select
                  options={serviceOptions}
                  value={serviceOptions.find(
                    (option) => option.value === service,
                  )}
                  onChange={(option) => {
                    setService(option.value);
                    setFormData({
                      ...formData,
                      service_category: option.value,
                    });
                  }}
                  placeholder="Select Service*"
                  required
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "flex-start",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 100,
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,

                      textAlign: "left",
                    }),
                  }}
                />
              </div>
            </Col>

            <Col xs={6} className="text-center mb-3 mb-md-0">
              <div
                className="border rounded p-3 d-flex flex-column align-items-center"
                style={{ height: "150px", cursor: "pointer" }}
                onClick={handleIconClick}
              >
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label className="d-flex flex-column align-items-center justify-content-center">
                    {formData.imagePreviewUrl ? (
                      <img
                        src={formData.imagePreviewUrl}
                        alt="Service"
                        style={{ height: "100px", objectFit: "cover" }}
                      />
                    ) : (
                      <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{ height: "100px" }}
                      >
                        <FaCloudUploadAlt size={50} />
                        <span>Upload Image</span>
                      </div>
                    )}
                    <input
                      type="file"
                      className="form-control-file d-none"
                      name="service_sub_image"
                      onChange={handleChange}
                      ref={inputRef}
                    />
                  </Form.Label>
                </Form.Group>
                {errors.service_sub_image && (
                  <div className="text-danger">{errors.service_sub_image}</div>
                )}
              </div>
            </Col>
          </Row>

          <Form.Floating>
            <Form.Control
              as="textarea"
              id="service_sub_cat_description"
              name="service_sub_cat_description"
              placeholder="Service Sub-Category Description"
              style={{ height: "100px" }}
              value={formData.service_sub_cat_description}
              onChange={handleChange}
              required
            />
            <label htmlFor="service_sub_cat_description">Description*</label>
          </Form.Floating>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ServiceSubCategoryModal;
